import type React from 'react';

import { useGetResources } from '@hooks/useGetResources';
import { VerktoyType } from '@src/types/minhelseentities';

import { TagComponent } from './tag-component';

interface Props {
  verktoyType: VerktoyType;
}

const VerktoyTypeTag = ({ verktoyType }: Props): React.JSX.Element => {
  const resources = useGetResources();
  if (verktoyType === VerktoyType.App) {
    return <TagComponent tagValue={resources?.verktoyType_App} />;
  } else {
    return <TagComponent tagValue={resources?.verktoyType_Weblosning} />;
  }
};

export default VerktoyTypeTag;
